<div class="news_question_content">
    <div class="news_question_title">
        {{this.translateService.instant('NEWS_QUESTION.TITLE').replace('#author#', this.questionAuthor)}}
    </div>
    <div class="news_question_text">&ldquo; {{this.question.content}} &rdquo;</div>
    <div class="news_question_actions">
        <div class="news_question_nb_answers">
            {{this.translateService.instant('NEWS_QUESTION.NB_ANSWERS').replace('#nb_answers#', this.nbAnswers)}}
            @if(this.nbAnswers > 0){
                <span (click)="this.seeAllAnswers()">{{'NEWS_QUESTION.SEE_ALL_ANSWERS' | translate}}</span>
            }
        </div>
        @if(!this.questionAnswered && this.question.responses.length <= 5){
            <demooz-button 
                type="button" 
                label="{{'NEWS_QUESTION.ANSWER' | translate}}"   
                [withMargin]="false"
                (click)="this.answerQuestion()"
                />    
        }
    </div>
</div>

<demooz-modal #modalAnswers size="small" (onDidDismiss)="this.onDidDismissModalAnswers($event)">    
    <div class="page_title_content" modal_header>
        <div class="page_title">{{'NEWS_QUESTION.ANSWERS_LIST' | translate}}</div>
    </div>
    <div class="news_question_answers_list">
        @for(response of this.question.responses; track $index){
            <div class="news_question_answer" [class.my_answer]="this.dataService.ambassador.value.ID === response.ambassadorID">
                <div class="news_question_answer_title">
                    @if(this.dataService.ambassador.value.ID === response.ambassadorID){
                        {{this.translateService.instant('NEWS_QUESTION.MY_RESPONSE_TITLE').replace('#date#', this.getAnswerDate(response.responseDate))}}
                    }
                    @else{
                        {{this.translateService.instant('NEWS_QUESTION.RESPONSE_TITLE').replace('#date#', this.getAnswerDate(response.responseDate))}}
                    }
                </div>
                <div class="news_question_answer_text">&ldquo; {{response.response}} &rdquo;</div>            
            </div>
        }
    </div>    
</demooz-modal>